import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setUnreadCount,
  incrementUnreadCount,
} from "../../redux/notifications";
import { getAuthUser } from "../../redux";
import config from "../../config/config";

export const useNotificationSSE = () => {
  const dispatch = useDispatch();
  const user = useSelector(getAuthUser);
  const userId = user?.id;

  useEffect(() => {
    if (!userId) return;

    let es;
    let reconnectTimer;

    const connect = () => {
      es = new EventSource(`${config.apiHost}/notifications/stream`, {
        withCredentials: true,
      });

      es.onmessage = (e) => {
        try {
          const data = JSON.parse(e.data);
          if (data.type === "init") dispatch(setUnreadCount(data.unreadCount));
          if (data.type === "notification") dispatch(incrementUnreadCount());
        } catch (_) {}
      };

      es.onerror = () => {
        es.close();
        reconnectTimer = setTimeout(connect, 5000);
      };
    };

    connect();

    return () => {
      es?.close();
      clearTimeout(reconnectTimer);
    };
  }, [userId, dispatch]);
};
